import { render, staticRenderFns } from "./_onlyImage.vue?vue&type=template&id=19b118fd"
import script from "./_onlyImage.vue?vue&type=script&lang=js"
export * from "./_onlyImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports